import { render, staticRenderFns } from "./IncomeAmountAggregationTable.vue?vue&type=template&id=364557da&"
import script from "./IncomeAmountAggregationTable.vue?vue&type=script&lang=js&"
export * from "./IncomeAmountAggregationTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports